<template>
  <div>
    <DefaultHeroTitle title="Checkout" />

    <v-container class="pt-0 mt-n8 mt-sm-0">
      <v-row class="">
        <v-col cols="12">
          <v-btn
            variant="text"
            :prepend-icon="mdiArrowLeft"
            tag="NuxtLink"
            to="/companies"
            class="ps-0"
          >
            Back
          </v-btn>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" offset-md="2" sm="8" md="6" class="mx-auto">
          <h3 class="title-h3 mb-4 text-center">Complete your purchase</h3>
          <v-skeleton-loader
            v-show="showLoadingPaypalBtns"
            type="heading, heading"
          />
          <div id="paypal-button-container-P-43E84467A04014000M2GAT4I"></div>
        </v-col>
        <v-col cols="12" offset-md="2" sm="8" md="6" class="mx-auto mb-8">
          <h3 class="title-h3 mb-4 text-center"> Summary </h3>
          <v-card elevation="1" max-width="750px">
            <v-card-title class="ps-8" />
            <v-card-text>
              <v-table>
                <thead>
                  <tr>
                    <th class="text-left"> Plan type </th>
                    <th class="text-left"> Price </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="plan">
                    <td>{{ plan.title }} Plan</td>
                    <td>{{ formattedPrice }}</td>
                  </tr>
                  <tr v-else>
                    <td colspan="2">
                      <v-skeleton-loader type="heading" />
                    </td>
                  </tr>
                </tbody>
              </v-table>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    <Snackbar
      v-model="showSnackbar"
      :content="snackbarContent"
      :type="snackbarType"
    />
  </div>
</template>

<script setup>
import { useRoute } from 'vue-router';
import { mdiArrowLeft } from '@mdi/js';

import { plans } from '@/constants/plans';
import { formatPrice } from '@/utils/format';

useHead({
  script: [
    {
      src: 'https://www.paypal.com/sdk/js?client-id=Afa9ixEQIlXawACzvJL3jff3Yg13VA9MrBiDu7jRCJ4fKfaHdRYXGZYwdWdqmrVOzeP36f3jmaAZgauI&vault=true&intent=subscription',
      'data-sdk-integration-source': 'button-factory',
      onload: paypalHandler,
    },
  ],
});

const route = useRoute();
const router = useRouter();

const plan = ref();

const showLoadingPaypalBtns = ref(true);

const { showSnackbar, snackbarType, snackbarContent, showSuccess } =
  useSnackbar();

onMounted(() => {
  plan.value = plans.find(
    (planElement) =>
      planElement.title === route.query.plan && planElement.price !== undefined,
  );

  if (!plan.value) router.push('/404');
});

const formattedPrice = computed(() => {
  if (plan.value.price) {
    return formatPrice(plan.value.price);
  }
  return '';
});

function paypalHandler() {
  showLoadingPaypalBtns.value = false;

  paypal
    ?.Buttons({
      style: {
        shape: 'rect',
        color: 'blue',
        layout: 'vertical',
        label: 'paypal',
      },
      createSubscription: function (data, actions) {
        switch (plan.value?.title.toLowerCase()) {
          case 'basic': {
            return actions.subscription.create({
              // Basic subscription
              /* Creates the subscription */
              plan_id: 'P-43E84467A04014000M2GAT4I',
              quantity: 1, // The quantity of the product for a subscription
            });
          }
          case 'advanced': {
            return actions.subscription.create({
              // Advanced subscription
              /* Creates the subscription */
              plan_id: 'P-1DV859355M177992LM2GBHBQ',
              quantity: 1, // The quantity of the product for a subscription
            });
          }
        }
      },
      onApprove: function (_) {
        // alert(); // You can add optional success message for the subscriber here
        showSuccess(
          `Thanks for purchasing! We will contact you shortly through the email provided to Paypal.
          You're a step away from improving your website/app!`,
        );
        setTimeout(() => {
          router.push('/companies');
        }, 5000);
      },
    })
    .render('#paypal-button-container-P-43E84467A04014000M2GAT4I'); // Renders the PayPal button
}
</script>

<style lang="scss" scoped></style>
